import Vue from 'vue'
import Router from 'vue-router'
import auth from './auth'
import home from './home'
import account from './account'
import influencer from './influencer'
import verification from './verification'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    auth,
    home,
    account,
    influencer,
    verification,
    {
      path: '/',
      name: 'auth.landing-page',
      component: () =>
        import(
          /* webpackChunkName: "landing-page" */ '@/views/Auth/LandingPage'
        ),
    },
    {
      path: '*',
      name: 'auth.not-found-page',
      component: () =>
        import(
          /* webpackChunkName: "not-found-page" */ '@/views/Auth/NotFound'
        ),
    },
  ],
  scrollBehavior() {
    window.scrollTo(0, 0)
  },
})
